// extracted by mini-css-extract-plugin
export default {"missingDegreeContainer":"hE8ZdeUxNScoR_vPriB2","dontKnowYet":"BHgxwKziVWfL3bZ1fuip","title":"yGxziXVg8Rg9csRxT2Bp","subtitleText":"EEYBn15fFEmsne_lnCdY"};